module.exports = __webpack_public_path__ + "static/media/domestic.2bf64e45.csv";